import React, { useContext, useRef } from 'react';

import { Avatar, Menu, Typography } from '@mui/material';

import { COLOR_BORDER } from '~/components/App/theme';
import { useLoggedUser } from '~/contexts/LoggedUserContext';
import { UserAuthContext } from '~/contexts/UserAuthContext';
import { BUILD_NUMBER, GIT_COMMIT, PACKAGE_VERSION } from '~/env';
import { useTrigger } from '~/hooks/useTrigger';

// 2 digits from PACKAGE_VERSION
const PACKAGE_SHORT_VERSION = PACKAGE_VERSION.split('.').slice(0, 2).join('.');
// 7 digits from GIT_COMMIT
const GIT_SHORT_COMMIT = GIT_COMMIT.substring(0, 7);

export const DisplayUser: React.FC = () => {
  const ref = useRef() as React.MutableRefObject<HTMLDivElement>;
  const loggedUser = useLoggedUser();
  const { logout } = useContext(UserAuthContext);
  const [open, menuHook] = useTrigger();

  if (!loggedUser) {
    return null;
  }

  return (
    <>
      <Avatar
        component="div"
        ref={ref}
        sx={{ height: '40px', width: '40px', cursor: 'pointer' }}
        alt={loggedUser.name} src={loggedUser.picture}
        onClick={menuHook.activate}
      />
      <Menu
        anchorEl={ref.current}
        open={open}
        onClose={menuHook.deactivate}
        PaperProps={{
          sx: { borderRadius: '6px' },
        }}
        MenuListProps={{
          role: 'listbox',
          sx: { p: 0 },
        }}
      >
        <Typography component="li" sx={{ mt: '18px', mb: '10px', mx: '20px' }}>
          {loggedUser.name}
        </Typography>
        <Typography
          component="li"
          onClick={logout}
          sx={{
            mb: '18px',
            mx: '20px',
            cursor: 'pointer',
            '&:hover, &:focus, &:active': {
              color: '#5980FF',
            },
          }}>
          Log Out
        </Typography>
        <Typography component="li" sx={{ textAlign: 'end', bgcolor: COLOR_BORDER, p: '6px 10px', fontSize: '14px' }}>
          Ver. {PACKAGE_SHORT_VERSION}.{BUILD_NUMBER} - {GIT_SHORT_COMMIT}
        </Typography>
      </Menu>
    </>
  );
}
